// Formato compartido por las gráficas de "Tiempos y ANS".
//
// Todo el modelo mide en minutos hábiles. El contrato, en cambio, habla en
// días hábiles ("3 días hábiles"), así que las gráficas se presentan en la
// unidad del contrato: es la que el cliente puede contrastar.
//
// Un día hábil son 600 minutos (lunes a viernes, 08:00 a 18:00). Ojo: la
// jornada real termina a las 17:00 los viernes, y el calendario del modelo no
// sabe expresarlo todavía. Son unas cuatro horas al mes contadas de más, en
// nuestra contra.
const MINUTOS_POR_DIA_HABIL = 600;
const MINUTOS_POR_HORA = 60;

export const BALL_OWNERS = {
  gw_queue: { etiqueta: "Globalwork (cola)", color: "#5F0091" },
  gw_working: { etiqueta: "Globalwork (gestión)", color: "#7B2FA8" },
  provider: { etiqueta: "Proveedor nuestro", color: "#9A5FC0" },
  candidate: { etiqueta: "Candidato", color: "#C9A3E0" },
  third_party: { etiqueta: "Un tercero", color: "#8FB8D9" },
  client: { etiqueta: "Tu equipo", color: "#6FA8C7" },
  force_majeure: { etiqueta: "Fuerza mayor", color: "#B8B8B8" },
  none: { etiqueta: "Sin asignar", color: "#D6D6D6" },
};

export const VALIDACIONES = {
  laboral: "Referencias laborales",
  personal: "Referencias personales",
  academic: "Verificación académica",
  antecedents: "Antecedentes",
  datacredito: "DataCrédito",
  visit: "Visita domiciliaria",
  polygraph: "Polígrafo",
  psychotechnical: "Pruebas psicotécnicas",
};

// El estado del reloj, dicho en cristiano. La urgencia es dato secundario en
// la bandeja, asi que las etiquetas son descriptivas y no alarmas.
export const URGENCIAS = {
  not_started: { etiqueta: "Sin iniciar", tono: "neutro" },
  on_track: { etiqueta: "Dentro del plazo", tono: "ok" },
  at_risk: { etiqueta: "Proxima al plazo", tono: "aviso" },
  // "Fuera de plazo" senala a alguien. "Plazo superado" dice el mismo hecho
  // en voz pasiva, que es lo que corresponde mientras la medicion se
  // termina de acordar con operacion.
  breached: { etiqueta: "Plazo superado", tono: "alerta" },
  met: { etiqueta: "Dentro del plazo", tono: "ok" },
  sin_plazo: { etiqueta: "Sin plazo pactado", tono: "neutro" },
};

export default {
  data() {
    return {
      // Gris neutro para todo lo que no es dato. El color se reserva para las
      // series.
      GW_GRIS: "#6b6b6b",
      GW_GRIS_SUAVE: "#9a9a9a",
      GW_MORADO: "#5F0091",
    };
  },

  methods: {
    // Una sola escala por gráfica: la unidad se decide con el máximo de la
    // serie y se aplica a todos sus valores. Mezclar horas y días dentro de
    // una misma gráfica obliga a leer cada barra por separado.
    unidadPara(valores) {
      const max = Math.max.apply(null, [0].concat(valores || []));
      if (max >= MINUTOS_POR_DIA_HABIL) {
        return { divisor: MINUTOS_POR_DIA_HABIL, sufijo: "días hábiles", corto: "d" };
      }
      return { divisor: MINUTOS_POR_HORA, sufijo: "horas hábiles", corto: "h" };
    },

    enUnidad(minutos, unidad) {
      if (minutos == null) return null;
      return Math.round((minutos / unidad.divisor) * 10) / 10;
    },

    // Para textos sueltos, donde no hay escala compartida que respetar.
    tiempoLegible(minutos) {
      if (minutos == null) return "—";
      if (minutos < MINUTOS_POR_DIA_HABIL) {
        return (Math.round((minutos / MINUTOS_POR_HORA) * 10) / 10) + " h hábiles";
      }
      return (Math.round((minutos / MINUTOS_POR_DIA_HABIL) * 10) / 10) + " días hábiles";
    },

    etiquetaResponsable(code) {
      return (BALL_OWNERS[code] || {}).etiqueta || code;
    },

    colorResponsable(code) {
      return (BALL_OWNERS[code] || {}).color || "#D6D6D6";
    },

    etiquetaUrgencia(estado) {
      return (URGENCIAS[estado] || URGENCIAS.sin_plazo).etiqueta;
    },

    tonoUrgencia(estado) {
      return (URGENCIAS[estado] || URGENCIAS.sin_plazo).tono;
    },

    // "desde hace 2 dias" es el titular de cada fila de la bandeja. Un "hoy"
    // o un "ayer" se leen mejor que "desde hace 0 dias".
    desdeHace(dias) {
      if (dias == null) return "";
      if (dias <= 0) return "hoy";
      if (dias === 1) return "desde ayer";
      return "desde hace " + dias + " días";
    },

    etiquetaValidacion(name) {
      return VALIDACIONES[name] || name;
    },

    fechaLegible(iso) {
      if (!iso) return "";
      const partes = String(iso).slice(0, 10).split("-");
      if (partes.length !== 3) return String(iso);
      const meses = ["enero","febrero","marzo","abril","mayo","junio",
                     "julio","agosto","septiembre","octubre","noviembre","diciembre"];
      return Number(partes[2]) + " de " + meses[Number(partes[1]) - 1] + " de " + partes[0];
    },
  },
};
